import { render } from "./InstantOrders.vue?vue&type=template&id=1d287e66&scoped=true"
import script from "./InstantOrders.vue?vue&type=script&lang=js"
export * from "./InstantOrders.vue?vue&type=script&lang=js"

import "./InstantOrders.vue?vue&type=style&index=0&id=1d287e66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d287e66"]])

export default __exports__